<template>
  <div class="pagination-bar">
    <div :class="props.theme.prev + ' arrow-link-item-player'" @click="props.setPrevPage">
      <a v-bind="{ ...props.aProps, ...props.prevProps }" class="arrow-link arrow-link-prev" title="Poprzednia strona">
        <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          ></path>
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="VuePagination" :class="props.theme.wrapper">
      <nav :class="props.theme.nav">
        <ul v-show="props.showPagination" :class="props.theme.list">
          <li
            v-if="props.hasEdgeNav"
            :class="props.theme.firstPage"
            @click="props.setFirstPage"
          >
            <a v-bind="{ ...props.aProps, ...props.firstPageProps }">{{
              props.texts.first
            }}</a>
          </li>

          <li
            v-if="props.hasChunksNav"
            :class="props.theme.prevChunk"
            @click="props.setPrevChunk"
          >
            <a v-bind="{ ...props.aProps, ...props.prevChunkProps }">{{
              props.texts.prevChunk
            }}</a>
          </li>

          <li :class="props.theme.prev" @click="props.setPrevPage" v-if="null">
            <a v-bind="{ ...props.aProps, ...props.prevProps }">{{
              props.texts.prevPage
            }}</a>
          </li>

          <li
            v-for="page in props.pages"
            :key="page"
            :class="props.pageClasses(page)"
            v-on="props.pageEvents(page)"
          >
            <a v-bind="props.aProps" :class="props.theme.link">{{ page }}</a>
          </li>

          <li :class="props.theme.next" @click="props.setNextPage" v-if="null">
            <a v-bind="{ ...props.aProps, ...props.nextProps }">{{
              props.texts.nextPage
            }}</a>
          </li>

          <li
            v-if="props.hasChunksNav"
            :class="props.theme.nextChunk"
            @click="props.setNextChunk"
          >
            <a v-bind="{ ...props.aProps, ...props.nextChunkProps }">{{
              props.texts.nextChunk
            }}</a>
          </li>

          <li
            v-if="props.hasEdgeNav"
            :class="props.theme.lastPage"
            @click="props.setLastPage"
          >
            <a v-bind="{ ...props.aProps, ...props.lastPageProps }">{{
              props.texts.last
            }}</a>
          </li>
        </ul>

        <p v-if="null" v-show="props.hasRecords" :class="props.theme.count">
          {{ props.count }}
        </p>
      </nav>
    </div>
    <div :class="props.theme.next + ' arrow-link-item-player'">
      <a v-bind="{ ...props.aProps, ...props.nextProps }" class="arrow-link arrow-link-next" @click="props.setNextPage" title="Kolejna strona">
        <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          ></path>
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          ></path>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>

// przepisac tak, ze po kliknieciu od razu uruchamia route z current i update page
//albo router link
      
export default {
  name: "GridPagination",
  props: ["props"],
  mounted() {},
};
</script>
<style scoped>
.disabled a {
  display: none;
}
.pagination {
  text-align: right;
  margin-bottom: 2em;
}
.active a {
  font-weight: bold;
  color: #c63;
}

.pagination-bar {
  display: flex;
  justify-content:space-around ;
  align-items: center;
  margin-top: 2em;
}

.arrow-link-prev {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.VuePagination__count {
}

.VuePagination ul {
  list-style-type: none;
}
.VuePagination ul li {
  padding: 10px;
  display: inline;
}
.VuePagination ul li a {
  cursor: pointer;
}
.VuePagination .page-link.active {
  cursor: pointer;
  font-weight: bold;
  color: #000;
}
.arrow-link-item-player a:hover {
    cursor: pointer;
} 
</style>


// WEBPACK FOOTER //
// src/components/Common/Grid/GridPagination.vue